import type React from 'react';

import { Image, Separator, Text } from '@change/ds-core-ui';

import { CmsHtml } from 'src/app/shared/components/cms';
import { Html } from 'src/app/shared/components/html';

import { usePageBody } from './hooks/usePageBody';

export const PageBody: React.FC = () => {
	const {
		data: { date, categoryName, title, content, styles, photoUrl, mobilePhotoUrl, photoCaption, photoAlt },
	} = usePageBody();

	return (
		<div className="container pt-14 pb-16 lg:max-w-2xl">
			<Text as="span" fontWeight="bold" size="small" className="text-typography-weak uppercase">
				{categoryName}
			</Text>
			<Text as="h1" variant="heading" className="wrap-break-word">
				{title}
			</Text>
			<Text as="span" size="medium" className="text-typography-weak">
				{date}
			</Text>
			{photoUrl && mobilePhotoUrl && (
				<div className="pt-10 pb-6 md:pb-10">
					<div className="block md:hidden">
						<Image
							src={mobilePhotoUrl}
							className="h-44 w-full object-cover"
							alt={photoAlt || ''}
							role={photoCaption ? 'img' : 'presentation'}
							aria-describedby={photoCaption ? 'news-photo-caption' : undefined}
						/>
					</div>
					<div className="hidden md:block">
						<Image
							src={photoUrl}
							className="h-80 w-full object-cover"
							alt={photoAlt || ''}
							role={photoCaption ? 'img' : 'presentation'}
							aria-describedby={photoCaption ? 'news-photo-caption' : undefined}
						/>
					</div>
					{photoCaption && (
						<>
							<Text id="news-photo-caption" as="div" className="mt-2 italic" size="x-small">
								<Html html={photoCaption} />
							</Text>
							<Separator orientation="horizontal" />
						</>
					)}
				</div>
			)}
			<CmsHtml html={content} styles={styles} />
		</div>
	);
};
